export const theme = {
    primaryDark: '#000',
    primaryLight: '#a7dae5',
    burgerDark: 'rgba(0,0,0,0.8)',
    secondaryLight: '#fff',
    primaryHover: '#fff',
    green: '#9CAF06',
    mobile: '786px',

  }